define('webStorage',[], function () {
  var WebStorage = WebStorage || {};

  /*
    Class: WebStorage

    This class adds functionality for session storage and local storage on older browsers that do not support it.
    It also adds this functionality to Safari private browsing mode which does not allow you to write
    to session storage

    This code was modified from code avaialble at https://gist.github.com/remy/350433

    Added a check for private browsing

  */

  /*
    Function: isStorageCapped
    Checks if there is any error writing to session storage by writing to session storage

    Returns:
      true if error writing to session storage
  */
  WebStorage.isStorageCapped = function () {
    try {
      sessionStorage.setItem('dummy', 'writetest');
      sessionStorage.removeItem('dummy');
    } catch (err) {
      return true;
    }
    return false;
  };

  /*
    Function: Storage

    Provides implementation of localStorage and sessionStorage

    localStorage implemented using a cookie.
    sessionStorage implemented through window.name. sessionStorage has 2MB limit. This is generous considering it can store just text
  */
  WebStorage.Storage = function (type) {
    function createCookie(name, value, days) {
      var date; var expires;

      if (days) {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
      } else {
        expires = '';
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }

    function readCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      var i; var c;

      for (i = 0; i < ca.length; i++) {
        c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }

    function setData(data) {
      data = JSON.stringify(data);
      if (type == 'session') {
        window.name = data;
      } else {
        createCookie('localStorage', data, 365);
      }
    }

    function clearData() {
      if (type == 'session') {
        window.name = '';
      } else {
        createCookie('localStorage', '', 365);
      }
    }

    function getData() {
      var data = type == 'session' ? window.name : readCookie('localStorage');
      return data ? JSON.parse(data) : {};
    }


    // initialise if there's already data
    var data = getData();

    return {
      length: 0,
      clear: function () {
        data = {};
        this.length = 0;
        clearData();
      },
      getItem: function (key) {
        return data[key] === undefined ? null : data[key];
      },
      key: function (i) {
        // not perfect, but works
        var ctr = 0;
        for (var k in data) {
          if (ctr == i) return k;
          else ctr++;
        }
        return null;
      },
      removeItem: function (key) {
        delete data[key];
        this.length--;
        setData(data);
      },
      setItem: function (key, value) {
        data[key] = value + ''; // forces the value to a string
        this.length++;
        setData(data);
      }
    };
  };

  /*
    Check and initialize storage options
  */
  var restrictedPrivateBrowsing = WebStorage.isStorageCapped();
  WebStorage.sessionStorage = (typeof window.sessionStorage == 'undefined' || restrictedPrivateBrowsing) ? new WebStorage.Storage('session') : window.sessionStorage;
  WebStorage.localStorage = (typeof window.localStorage == 'undefined' || restrictedPrivateBrowsing) ? new WebStorage.Storage('local') : window.localStorage;

  /*
    Function: getSessionStorage
    Get access to storage that will persist till window is closed
  */
  WebStorage.getSessionStorage = function () {
    return WebStorage.sessionStorage;
  };

  /*
    Function: getLocalStorage
    Get access to storage that will persist for a year
  */
  WebStorage.getLocalStorage = function () {
    return WebStorage.localStorage;
  };

  return WebStorage;
});

